import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const testimonials = [
	{
		id: 1,
		img: "/assets/sayantika-manna.png",
		text: "I had a great experience with Fine Labs! The platform is super easy to use, and everything works smoothly. The attention to detail really shows, and it makes managing medical needs so much easier. Definitely a top choice if you're looking for something reliable.",
		author: "Sayantika Manna",
	},
	{
		id: 2,
		img: "/assets/Vaibhav Verma.jpg",
		text: "I recently used this website for lab testing, and my experience was outstanding! Booking a lab test from home was incredibly easy. Their team collected the sample on time and handled the entire process professionally. The best part was that I received my reports accurately and on time.",
		author: "Vaibhav Verma",
	},
	{
		id: 3,
		img: "/assets/prikshit-singh.png",
		text: "FineLabs made my health testing experience seamless. The process was straightforward, the results arrived quickly, and the lab quality exceeded my expectations. I'd definitely recommend them!",
		author: "Prikshit Singh",
	},
	{
		id: 4,
		img: "/assets/rohit-saini.png",
		text: "I've used FineLabs for my health tests, and I'm really impressed. The process was easy, the results were fast, and the quality of the labs is top-notch. Definitely recommend!",
		author: "Rohit Saini",
	},
	{
		id: 5,
		img: "/assets/jony-rao-shab.png",
		text: "Really nice experience, On time home collection. Recommended 👍 …",
		author: "Jony Rao Shab",
	},
	{
		id: 6,
		img: "/assets/dishant-rawal.png",
		text: "Trustable lab. I tried so many times for my regular blood Checkup. They are very fast and accurate by result with home sample collection 👌👌",
		author: "Dishant Rawal",
	},
	{
		id: 7,
		img: "/assets/vineetha-dunna.jpg",
		text: "Fine Labs offers great products at low cost with a simple and well-designed website.",
		author: "Vineetha Dunna",
	},
	{
		id: 8,
		img: "/assets/sigma-insaan.png",
		text: "This is useful platform for booking lab tests from top labs at good prices. Recommend 👍 …",
		author: "Sigma Insaan",
	},
	{
		id: 9,
		img: "/assets/dhanji-sah.png",
		text: "Affordable price and on time home collection. Go for it 👍 …",
		author: "Dhanji Sah",
	},
	{
		id: 10,
		img: "/assets/cater.png",
		text: "It's totally good ..nice one",
		author: "Cater",
	},
	{
		id: 11,
		img: "/assets/pagal-ladka.png",
		text: "Affordable pricing with good experience",
		author: "Pagal Ladka",
	},
	{
		id: 12,
		img: "/assets/sudhir-sangwan.png",
		text: "Awesome 👍. Keep going on ❤️. …",
		author: "Sudhir Sangwan",
	},
	{
		id: 13,
		img: "/assets/sachin-kumar.png",
		text: "Grt experience thanku sir",
		author: "Sachin Kumar",
	},
	{
		id: 14,
		img: "/assets/ram-kumar.png",
		text: "Very nice",
		author: "Ram Kumar",
	},
	{
		id: 15,
		img: "/assets/sanjay-kumar.png",
		text: "Very good.",
		author: "Sanjay Kumar",
	},
];

const Testimonial = () => {
	const [currentGroup, setCurrentGroup] = useState(0);
	const [isAnimating, setIsAnimating] = useState(false);
	const [deviceOs, setDeviceOS] = useState(false);
	const [testimonialsPerGroup, setTestimonialsPerGroup] = useState(3);

	const totalGroups = Math.ceil(testimonials.length / testimonialsPerGroup);

	// Touch/swipe states
	const [touchStart, setTouchStart] = useState(null);
	const [touchEnd, setTouchEnd] = useState(null);

	useEffect(() => {
		function updateTestimonialsPerGroup() {
			if (window.innerWidth < 768) setTestimonialsPerGroup(1); // mobile
			else if (window.innerWidth < 1024) setTestimonialsPerGroup(2); // tablet
			else setTestimonialsPerGroup(3); // desktop
		}
		updateTestimonialsPerGroup();
		window.addEventListener("resize", updateTestimonialsPerGroup);
		return () =>
			window.removeEventListener("resize", updateTestimonialsPerGroup);
	}, []);

	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentGroup((prevGroup) => (prevGroup + 1) % totalGroups);
		}, 10000);
		return () => clearInterval(interval);
	}, [totalGroups]);

	const goToGroup = (groupIndex) => {
		if (groupIndex !== currentGroup && !isAnimating) {
			setIsAnimating(true);
			setCurrentGroup(groupIndex);
			setTimeout(() => setIsAnimating(false), 500);
		}
	};

	// Swipe handling functions
	const handleTouchStart = (e) => {
		setTouchEnd(null);
		setTouchStart(e.targetTouches[0].clientX);
	};

	const handleTouchMove = (e) => {
		setTouchEnd(e.targetTouches[0].clientX);
	};

	const handleTouchEnd = () => {
		if (!touchStart || !touchEnd) return;

		const distance = touchStart - touchEnd;
		const isLeftSwipe = distance > 50;
		const isRightSwipe = distance < -50;

		if (isLeftSwipe && currentGroup < totalGroups - 1) {
			goToGroup(currentGroup + 1);
		}
		if (isRightSwipe && currentGroup > 0) {
			goToGroup(currentGroup - 1);
		}
	};

	const [isReadMore, setIsReadMore] = useState({ status: false, id: null });

	return (
		<div className='w-full min-h-[55vh] lg:min-h-[70vh] bg-gradient-to-b from-[#0047AFCC] to-[#0047AF8D] lg:px-[5%] py-[7.5%] lg:py-[3%] flex flex-col items-center mt-[3%] relative overflow-hidden'>
			<p className='font-semibold text-[22px] lg:text-[28px] text-white text-center mb-[7.5%] lg:mb-[5%]'>
				What our customers are saying
			</p>

			<div
				className='w-full max-w-[100%] rounded-md  relative overflow-hidden mb-20'
				onTouchStart={handleTouchStart}
				onTouchMove={handleTouchMove}
				onTouchEnd={handleTouchEnd}>
				<div
					className='flex transition-transform duration-500  ease-in-out'
					style={{ transform: `translateX(-${currentGroup * 100}%)` }}>
					{Array.from({ length: totalGroups }).map((_, groupIndex) => {
						const groupTestimonials = testimonials.slice(
							groupIndex * testimonialsPerGroup,
							(groupIndex + 1) * testimonialsPerGroup
						);

						return (
							<div
								key={groupIndex}
								// className={`w-full flex-shrink-0 grid gap-6 lg:gap-8 px-4 lg:px-0 ${
								//   deviceOs === "android" || deviceOs === "ios" ? 'grid-cols-1 place-items-center' : 'grid-cols-3'
								// }`}
								className='w-full flex-shrink-0 grid  lg:gap-6 px-4 lg:px-0 grid-cols-1 md:gap-6 md:grid-cols-2 md:m-2 lg:grid-cols-3 place-items-center'>
								{groupTestimonials.map((testimonial) => (
									<div
										key={testimonial.id}
										className={`
										flex flex-col justify-center relative items-center text-center bg-white rounded-[20px]
										w-full max-w-[80%] sm:max-w-[380px] md:max-w-[385px] lg:max-w-[390px]
										min-h-[260px] md:min-h-[294px]
										px-4 py-6 sm:px-6 md:px-4
										transition-all duration-300 shadow-lg
										${isReadMore.id === testimonial.id
												? "min-h-[350px] md:min-h-[420px] lg:min-h-[440px]"
												: ""
											}
      									m-auto
    			`}>
										<img
											src='/assets/quotation-marks.png'
											className='absolute top-3 left-3 w-7 h-7 md:w-9 md:h-9 opacity-30'
											alt=''
										/>
										{isReadMore.id === testimonial.id ? (
											<p className='font-normal text-[13px] sm:text-[14px] lg:text-[15px] text-[#141219] mb-4 leading-relaxed text-justify'>
												{testimonial.text}
												<span
													className='block mt-1 text-[#0047AF] font-semibold underline cursor-pointer text-right'
													onClick={() =>
														setIsReadMore({ status: false, id: "" })
													}>
													See less...
												</span>
											</p>
										) : (
											<p className='font-normal text-[13px] sm:text-[14px] lg:text-[15px] text-[#141219] mb-4 leading-relaxed text-justify'>
												{testimonial.text.slice(0, 100)}
												{testimonial.text.length > 100 && (
													<span
														className='block mt-1 text-[#0047AF] font-semibold underline cursor-pointer text-right'
														onClick={() =>
															setIsReadMore({
																status: true,
																id: testimonial.id,
															})
														}>
														See more...
													</span>
												)}
											</p>
										)}
										<div className='absolute bottom-3 left-4 right-4 flex items-center justify-between'>
											<div className='flex items-center space-x-2'>
												<img
													src={testimonial.img}
													alt={testimonial.author}
													className='w-10 h-10 rounded-full object-cover border-2 border-[#E0E7FF]'
												/>
												<span className='font-medium text-[14px] sm:text-[15px] text-[#141219] leading-tight'>
													{testimonial.author}
												</span>
											</div>
											<img
												src='/assets/five-stars.png'
												className='h-[20px] w-[101px] ml-auto'
												alt=''
											/>
										</div>
									</div>
								))}
							</div>
						);
					})}
				</div>
			</div>

			{/* Dots Navigation */}
			<div
				className={`flex ${deviceOs === "android" || deviceOs === "ios" ? "gap-2" : "gap-3"
					} absolute bottom-[18%] lg:bottom-[18%]`}>
				{Array.from({ length: totalGroups }).map((_, index) => (
					<button
						key={index}
						onClick={() => goToGroup(index)}
						disabled={isAnimating}
						className={`${deviceOs === "android" || deviceOs === "ios"
								? "w-[8px] h-[8px]"
								: "w-[24px] h-[8px]"
							} rounded-[40px] transition-all duration-300  ${index === currentGroup
								? "bg-white shadow-lg"
								: "bg-white/40 hover:bg-white/60"
							} ${isAnimating ? "" : "cursor-pointer"}`}
					/>
				))}
			</div>
			<Link
				target='_blank'
				to='https://www.google.com/maps/place/Fine+Labs/@28.4865276,77.0244388,17z/data=!4m8!3m7!1s0xa3e5f924b4e1bff9:0x509b3376e8a8aa92!8m2!3d28.4865276!4d77.0244388!9m1!1b1!16s%2Fg%2F11w_cyndk_?entry=ttu&g_ep=EgoyMDI1MDcwNi4wIKXMDSoASAFQAw%3D%3D'
				className='bg-gradient-to-r from-[#0047AF] to-[#1A67D8] text-white rounded-full absolute bottom-[2%] lg:bottom-[2%]'>
				<button style={{ width: "112px", height: 56 }}>View all</button>
			</Link>
		</div>
	);
};

export default Testimonial;
